export function isDefaultCountry(country) {
  return country === 'US';
}
export function isDefaultLanguage(language) {
  return language === 'en';
}